import { render } from "./App.vue?vue&type=template&id=1ba47c70"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1ba47c70&lang=css"
import "./App.vue?vue&type=style&index=1&id=1ba47c70&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__